<div
	[ngClass.gt-xs]="{
		'custom-theme-branding': !(data?.qrUrl && data?.qrLogoUrl),
		'p-m': true
	}"
	[ngClass.lt-sm]="{
		'custom-theme-branding': !(data?.qrUrl && data?.qrLogoUrl),
		'p-0': true
	}"
>
	<div fxLayout="column" *ngIf="!(this.data?.qrUrl && this.data?.qrLogoUrl)">
		<div fxLayout="row" fxLayoutAlign="space-between">
			<div>
				<button mat-icon-button (click)="onBackClick()">
					<mat-icon>chevron_left</mat-icon>
				</button>
			</div>
			<div>
				<button 
				id="qrCodeCloseButton"
				mat-icon-button (click)="onCloseClick()">
					<mat-icon>close</mat-icon>
				</button>
			</div>
		</div>
	</div>
	<div
		fxLayout="column"
		*ngIf="this.data?.qrUrl && this.data?.qrLogoUrl"
		fxFill
		fxLayoutAlign="flex-end flex-end"
	>
		<button
		id="qrCodeCloseButton"
		 mat-icon-button (click)="onCloseClick()">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div fxLayout="column">
		<div fxLayout.gt-sm="row" fxLayout.lt-md="column">
			<div fxLayout="column" fxFlex.gt-md="66%" fxFlex.md="60%">
				<div ngClass="p-m">
					<div
						fxLayout="row wrap"
						fxLayoutGap.gt-xs="1%"
						fxLayoutAlign="start baseline"
					>
						<h2 i18n="@@qrcode_popup_title"
							>QR Code for</h2
						>
						<h2>{{ getLocalizedTitle() }}</h2>
					</div>
					<div ngClass.gt-md="p-r-l">
						<div fxLayout="row" class="grey-bg" ngClass="p-m">
							<span>{{ urlToShare }}</span>
						</div>
					</div>
					<div fxLayout="row" ngClass="p-t-m">
						<h3 i18n="@@qrcode_add_logo">Add Logo</h3>
					</div>
					<div
						fxLayout.gt-xs="row"
						fxLayout.lt-sm="column"
						fxLayoutGap="5%"
						fxLayoutAlign.gt-xs="start center"
						fxLayoutAlign.lt-sm="start start"
					>
						<!-- Image Preview AND Cropper -->
						<div fxLayout="column" ngClass="p-m" class="border-div">
							<!-- Show image cropper if cropping, else show the logo -->
							<image-cropper
								*ngIf="showCropper"
								[style.width.px]="200"
								[imageChangedEvent]="imageChangedEvent"
								[maintainAspectRatio]="true"
								[aspectRatio]="1 / 1"
								[resizeToWidth]="200"
								[resizeToHeight]="200"
								format="png"
								(imageCropped)="imageCropped($event)"
							></image-cropper>

							<img
								*ngIf="!showCropper"
								[src]="logoPreviewImage"
								width="200px"
							/>
						</div>

						<div fxLayout="column" fxLayoutGap="2%">
							<!-- File Upload & Crop Buttons -->
							<div fxLayout="row">
								<input
									#customLogoUploader
									fxHide
									type="file"
									accept="image/png, image/jpeg, image/jpg, image/webp"
									id="upload_image_input"
									(change)="fileChangeEvent($event)"
								/>

								<!-- Upload button (Hidden when cropper is shown) -->
								<button
									*ngIf="!showCropper"
									mat-stroked-button
									color="accent"
									(click)="customLogoUploader.click()"
									i18n="@@custom-branding-upload-your-logo"
								>
									Upload your logo
								</button>

								<!-- Crop button (Shown only when cropper is active) -->
								<button
									*ngIf="showCropper"
									mat-stroked-button
									color="accent"
									(click)="cropImage()"
									i18n="@@button_cropImage"
								>
									Crop Logo
								</button>
							</div>

							<div class="mat-caption" fxLayout="row">
								<mat-hint i18n="@@qrlogo_upload_hint">
									Maximum 5MB (JPG/PNG/WebP) | Aspect ratio: 1:1
								</mat-hint>
							</div>
						</div>
					</div>
				</div>
				<div
					fxLayout="row wrap"
					ngClass.lt-sm="p-s"
					ngClass.gt-xs="p-m"
					fxLayoutGap="4%"
				>
					<div fxLayout="column">
						<div fxLayout="row">
							<h3 i18n="@@qrcode_file_type">File Type</h3>
						</div>
						<div fxLayout="row">
							<mat-button-toggle-group
								id="fileTypeToggleId"
								[(ngModel)]="userSelectedFormat"
								(change)="onFormatChange(userSelectedFormat)"
								[ngClass]="
									data?.qrUrl && data?.qrLogoUrl
										? 'mat-toggle-color'
										: 'mat-toggle-color-custom'
								"
							>
								<mat-button-toggle value="png">PNG</mat-button-toggle>
								<mat-button-toggle value="svg">SVG</mat-button-toggle>
								<mat-button-toggle value="eps">EPS</mat-button-toggle>
								<mat-button-toggle value="jpg">JPG</mat-button-toggle>
							</mat-button-toggle-group>
						</div>
					</div>
					<div fxLayout="column">
						<div fxLayout="row" ngClass.md="p-t-m" ngClass.xs="p-t-m">
							<h3 i18n="@@qrcode_size">Size</h3>
						</div>
						<div fxLayout="row">
							<mat-button-toggle-group
								id="sizeToggleId"
								[(ngModel)]="selectedSize"
								(change)="onSizeChange(selectedSize)"
								[ngClass]="
									data?.qrUrl && data?.qrLogoUrl
										? 'mat-toggle-color'
										: 'mat-toggle-color-custom'
								"
							>
								<div fxLayout="row">
									<mat-button-toggle value="1024">1024px</mat-button-toggle>
									<mat-button-toggle value="512">512px</mat-button-toggle>
									<mat-button-toggle value="256">256px</mat-button-toggle>
									<mat-button-toggle value="128">128px</mat-button-toggle>
									<mat-button-toggle value="64">64px</mat-button-toggle>
								</div>
							</mat-button-toggle-group>
						</div>
					</div>
				</div>
				<div fxLayout="row" ngClass="p-m" fxHide.lt-sm>
					<div fxLayout="column">
						<div fxLayout="row" fxLayoutGap="5%">
							<button
								id="saveButtonQrCode"
								mat-stroked-button
								color="accent"
								[disabled]="
									isSaving ||
									!isSizeSelected ||
									!isFormatSelected ||
									isAuthUserUpdate
								"
								(click)="uploadQRCodeData()"
							>
								<div
									ngClass="p-l-l p-r-l"
									fxLayout="row"
									fxLayoutAlign="center center"
									class="mat-title"
								>
									<span i18n="@@button_save_apply">Save</span>
									<div ngClass="p-l-s" *ngIf="isLoading">
										<mat-spinner color="accent" diameter="16"> </mat-spinner>
									</div>
								</div>
							</button>
							<button
								id="downloadButtonQrCode"
								mat-flat-button
								color="accent"
								[disabled]="
									isSaving ||
									!isSizeSelected ||
									!isFormatSelected ||
									isAuthUserUpdate
								"
								(click)="downloadQRCode()"
							>
								<div
									i18n="@@qrcode_download"
									class="mat-title"
								>
									Download
								</div>
							</button>
						</div>
					</div>
				</div>

				<div
					fxLayout="column"
					fxLayoutGap="4%"
					fxHide.gt-xs
					ngClass="p-t-xl p-m"
				>
					<button
					id="downloadButtonQrCode"
						mat-flat-button
						color="accent"
						[disabled]="
							isSaving ||
							!isSizeSelected ||
							!isFormatSelected ||
							isAuthUserUpdate
						"
						(click)="downloadQRCode()"
					>
						<div i18n="@@qrcode_download">
							Download
						</div>
					</button>
					<button
						id="saveButtonQrCode"
						mat-stroked-button
						color="accent"
						[disabled]="
							isSaving ||
							!isSizeSelected ||
							!isFormatSelected ||
							isAuthUserUpdate
						"
						(click)="uploadQRCodeData()"
					>
						<div
							fxLayout="row"
							fxLayoutAlign="center center"
						>
							<span i18n="@@button_save_apply">Save</span>
							<div ngClass="p-l-s" *ngIf="isLoading">
								<mat-spinner color="accent" diameter="16"> </mat-spinner>
							</div>
						</div>
					</button>
				</div>
			</div>
			<div
				fxLayout="column"
				fxFlex.lg="30%"
				fxFlex.md="40%"
				ngClass.lt-md="p-t-l p-l-m p-b-m"
			>
				<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3%">
					<img
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/visibilityOn/public"
					/>
					<span class="mat-subtitle-2" i18n="@@button_preview">Preview</span>
				</div>
				<div fxLayout="row" fxLayoutAlign="start" ngClass="p-t-m">
					<div
						fxLayout="column"
						ngClass="p-m"
						class="grey-bg"
						fxLayoutAlign="center center"
					>
						<div
							id="qr-code-preview"
							[style.width.px]="previewSize"
							[style.height.px]="previewSize"
						></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div fxLayout="column" ngClass="p-m" *ngIf="!isLoggedIn">
		<div
			fxLayout="row wrap"
			fxLayoutAlign="start center"
			class="qrCodeBackground"
			ngClass="p-m"
			fxLayoutAlign="start center"
			fxLayoutGap="1%"
		>
			<img
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/infoBlueNew/public"
			/>
			<span i18n="@@qrcode_login_prompt">Want to save the Custom QR Code?</span
			><a
				(click)="routeToLogin()"
				class="link-decorate-style pointer"
				i18n="@@button_login"
				id="loginButton"
				>Login</a
			>
		</div>
	</div>
</div>
